export const modalStyles = {
  modalOverlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.25)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  } as React.CSSProperties,

  // Cancel Modal Styles
  modalContainer: {
    width: '650px',
    background: '#fff',
    borderRadius: '6px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
    padding: '30px',
  } as React.CSSProperties,

  modalTitle: {
    fontSize: '22px',
    fontWeight: 600,
    color: '#2b4d6e',
    marginBottom: '15px',
  } as React.CSSProperties,

  modalDescription: {
    fontSize: '16px',
    color: '#444',
    lineHeight: 1.6,
  } as React.CSSProperties,

  modalButtons: {
    marginTop: '25px',
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  } as React.CSSProperties,

  btnNo: {
    background: '#0E1664',
    color: 'white',
    border: 'none',
    padding: '8px 28px',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
  } as React.CSSProperties,

  btnNoHover: {
    background: '#e0e0e0',
  } as React.CSSProperties,

  btnYes: {
    background: '#d32f2f',
    color: 'white',
    border: 'none',
    padding: '10px 25px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    minWidth: '80px',
    transition: 'background-color 0.3s',
  } as React.CSSProperties,

  btnYesHover: {
    background: '#b71c1c',
  } as React.CSSProperties,

  modalInfo: {
    background: 'lightgrey',
    padding: '15px',
    fontSize: '13px',
    color: '#333',
    display: 'flex',
    gap: '10px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    margin: 0,
  } as React.CSSProperties,

  infoIcon: {
    width: '22px',
    height: '22px',
    border: '1px solid #777',
    borderRadius: '50%',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: '1px',
  } as React.CSSProperties,

  // Confirm On Modal Styles
  modalBox: {
    width: '700px',
    background: 'white',
    borderRadius: '6px',
    padding: '35px 40px',
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.2)',
  } as React.CSSProperties,

  modalBoxTitle: {
    fontSize: '26px',
    fontWeight: 600,
    color: '#2b567a',
    marginBottom: '25px',
  } as React.CSSProperties,

  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '18px',
  } as React.CSSProperties,

  infoText: {
    fontSize: '18px',
    color: '#444',
    lineHeight: 1.6,
    margin: 0,
  } as React.CSSProperties,

  buttonRow: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'center',
    gap: '25px',
  } as React.CSSProperties,

  btnOutline: {
    padding: '10px 26px',
    borderRadius: '8px',
    border: '1px solid #777',
    background: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  } as React.CSSProperties,

  btnOutlineHover: {
    background: '#f5f5f5',
  } as React.CSSProperties,

  btnPrimary: {
    padding: '10px 26px',
    borderRadius: '8px',
    border: 'none',
    background: '#0E1664',
    color: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  } as React.CSSProperties,

  btnPrimaryHover: {
    background: 'linear-gradient(#2d6bb0, #083a75)',
  } as React.CSSProperties,

  // Success Modal Styles
  successBox: {
    width: '700px',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.25)',
  } as React.CSSProperties,

  successHeader: {
    background: '#184c73',
    color: 'white',
    fontSize: '26px',
    padding: '25px 35px',
    fontWeight: 600,
  } as React.CSSProperties,

  successContent: {
    background: 'white',
    padding: '35px',
  } as React.CSSProperties,

  successContentInfoRow: {
    marginBottom: '18px',
  } as React.CSSProperties,

  successContentInfoRowP: {
    margin: 0,
    fontSize: '16px',
    color: '#444',
    lineHeight: 1.5,
  } as React.CSSProperties,

  okButtonRow: {
    marginTop: '25px',
    display: 'flex',
    justifyContent: 'center',
  } as React.CSSProperties,

  okButtonRowBtnPrimary: {
    padding: '10px 28px',
    borderRadius: '8px',
    border: 'none',
    background: '#0E1664',
    color: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  } as React.CSSProperties,
}
